import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { ApplicationClientCommonModule, MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { CEPTabletComponent } from './component/cep-tablet.component';
import { CEPProfileTileComponent } from './component/profile-tile/cep-profile-tile.component';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';
import { CEPCameraTileComponent } from './component/camera-tile/cep-camera-tile.component';

@NgModule({
  declarations: [
    CEPTabletComponent,
    CEPProfileTileComponent,
    CEPCameraTileComponent
  ],
  exports: [
    CEPTabletComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonLayoutModule,
    CommonUIModule,
    ReactiveFormsModule,
    FormsModule,
    TmcYardCommonModule,
    TransportDetailsModule,
    ServiceResponseModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ]
})
export class CEPTabletModule { }
